import RowButton from 'components/atoms/row-button'
import SelectTableFilter from 'components/atoms/select-table-filter'
import ProductBrandClassificationBadge from 'domains/product-brand/atoms/classification-badge/product-brand-classification-badge'
import {
  STATUS,
  SEARCHABLE
} from 'domains/product-brand/constants'
import PropTypes from 'prop-types'
import React from 'react'
import StatusBadge from 'domains/product-brand/atoms/status-badge'
import GeneralStatusBadge from 'components/atoms/status-badge'

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const filterPropTypes = {
  column: PropTypes.object
}

const productBrandTableColumns = ({
  handleEnableBrand,
  handleDisableBrand,
  handleOpenUpdateModal
}) => {

  const StatusCell = (row) => <StatusBadge status={ row.cell.value } />
  const ClassificatiosCell = (row) => (
    row.cell.value.map( (classification) => (
      <ProductBrandClassificationBadge key={ `classification-tag-${classification.id}` } classification={ classification } />
    )
    ))

  const StatusTypeFilter = ({ column }) => {
    const options = Object.keys(STATUS).map((key) => (
      {
        label : STATUS[key],
        value : STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  const ActionCell = ({ cell: { row } }) => (
    <div className='d-flex justify-content-center'>
      {
        row.original.status == STATUS.ENABLED ?
          <RowButton
            data={ row.original }
            color='danger'
            onClick={ handleDisableBrand }
            text='Disable'
          />
          :
          <RowButton
            data={ row.original }
            color='success'
            onClick={ handleEnableBrand }
            text='Enable'
          />
      }
      <RowButton
        data={ row.original }
        color='primary'
        onClick={ handleOpenUpdateModal }
        text='Update'
      />
    </div>
  )

  const IsSearchableCell = (row) => {
    const isSearchable = row.cell.value
    const color        = isSearchable ? 'primary' : 'info'
    const label        = isSearchable ? 'Yes' : 'No'

    return (
      <GeneralStatusBadge
        className={ 'badge-lg' }
        color={ color }
        label={ label }
      />
    )
  }
  // eslint-disable-next-line react/prop-types
  const IsSearchableFilter = ({ column }) => {
    const searchableKeys = Object.keys(SEARCHABLE)
    const options        = searchableKeys.map((key) => (
      {
        label : key,
        value : SEARCHABLE[key]
      }
    ))

    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }
  ActionCell.propTypes       = actionCellPropTypes
  StatusTypeFilter.propTypes = filterPropTypes

  return (
    [
      {
        Header   : 'Label',
        accessor : 'label'
      },
      {
        Header         : 'Url',
        accessor       : 'url',
        disableFilters : true
      },
      {
        Header   : <>Classifications</>,
        accessor : 'classifications',
        id       : 'classification',
        Cell     : ClassificatiosCell
      },
      {
        Header   : <>Status</>,
        accessor : 'status',
        id       : 'status',
        Filter   : StatusTypeFilter,
        Cell     : StatusCell
      },
      {
        Header   : 'Searchable',
        accessor : 'is_searchable',
        Cell     : IsSearchableCell,
        Filter   : IsSearchableFilter
      },
      {
        Header : 'Actions',
        Cell   : ActionCell
      }
    ]
  )
}

export default productBrandTableColumns